import { useHasPermission } from '@shared/hooks/useHasPermission';
import SidebarMenuItem from './SidebarMenuItem';
import SidebarRecursiveMenu from './SidebarRecursiveMenu';
import SidebarSubMenu from './SidebarSubMenu';

const SidebarRecursiveMenuItem = ({ menuItem, currentLevel, sidebarIsCollapsed }) => {
    const userHasPermissionToRoute = useHasPermission(menuItem.permission);

    if (menuItem.hidden || !userHasPermissionToRoute) {
        return null;
    }

    if (!menuItem.children) {
        return <SidebarMenuItem key={menuItem.label} menuItem={menuItem} currentLevel={currentLevel} />;
    }

    return (
        <SidebarSubMenu menuItem={menuItem} currentLevel={currentLevel} sidebarIsCollapsed={sidebarIsCollapsed}>
            <SidebarRecursiveMenu menuItems={menuItem.children} currentLevel={currentLevel + 1} />
        </SidebarSubMenu>
    );
};

export default SidebarRecursiveMenuItem;
